import { Link } from "react-router-dom";
import { useSite } from "@/lib/SiteContext";
import { NewsletterForm } from "@/components/NewsletterForm";

export const Footer = () => {
  const { site } = useSite();
  const business = site?.business || {};
  const footerContent = site?.content?.footer || {};
  const nlContent = site?.content?.newsletter || {};
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-choco-line bg-[#120906]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <img src="/assets/logo.png" alt="Bakes by CR" className="h-16 w-auto" data-testid="footer-logo" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream-muted">
              {footerContent.tagline || "Handmade brownies, blondies, cookies and grazing tables — baked to order, every week."}
            </p>
            <p className="mt-4 text-sm text-cream-muted">
              {business.email && (
                <a href={`mailto:${business.email}`} className="block hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus rounded" data-testid="footer-email-link">
                  {business.email}
                </a>
              )}
              {business.phone && <span className="mt-1 block" data-testid="footer-phone">{business.phone}</span>}
            </p>
          </div>

          <nav className="md:col-span-2" aria-label="Explore">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Explore</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="text-cream-muted hover:text-gold" to="/shop" data-testid="footer-shop-link">Shop Bakes</Link></li>
              <li><Link className="text-cream-muted hover:text-gold" to="/about" data-testid="footer-about-link">Our Story</Link></li>
              <li><Link className="text-cream-muted hover:text-gold" to="/events" data-testid="footer-events-link">Grazing Tables</Link></li>
              <li><Link className="text-cream-muted hover:text-gold" to="/faqs" data-testid="footer-faqs-link">FAQs</Link></li>
            </ul>
          </nav>

          <nav className="md:col-span-3" aria-label="Help">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">Help</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="text-cream-muted hover:text-gold" to="/delivery-collection" data-testid="footer-delivery-link">Delivery & Collection</Link></li>
              <li><Link className="text-cream-muted hover:text-gold" to="/allergens" data-testid="footer-allergens-link">Allergen Information</Link></li>
              <li><Link className="text-cream-muted hover:text-gold" to="/contact" data-testid="footer-contact-link">Contact Us</Link></li>
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-gold">{nlContent.heading || "Join Our Newsletter"}</h3>
            <p className="mt-4 text-sm text-cream-muted">{nlContent.heading ? (nlContent.description || "") : "Recipes and exclusive offers, straight to your inbox."}</p>
            <div className="mt-4">
              <NewsletterForm compact />
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-choco-line pt-6 text-xs text-cream-muted sm:flex-row sm:items-center">
          <p data-testid="footer-copyright">© {year} Bakes by CR. All rights reserved.{footerContent.smallprint ? ` ${footerContent.smallprint}` : ""}</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2" aria-label="Legal">
            <Link className="hover:text-gold" to="/legal/terms" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <Link className="hover:text-gold" to="/legal/cancellation-refunds" data-testid="footer-refunds-link">Cancellation &amp; Refunds</Link>
            <Link className="hover:text-gold" to="/legal/delivery-collection" data-testid="footer-legal-delivery-link">Delivery &amp; Collection</Link>
            <Link className="hover:text-gold" to="/legal/allergen-information" data-testid="footer-legal-allergens-link">Allergen Information</Link>
            <Link className="hover:text-gold" to="/legal/privacy" data-testid="footer-privacy-link">Privacy Notice</Link>
            <Link className="hover:text-gold" to="/legal/cookies" data-testid="footer-cookies-link">Cookie Policy</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};
